function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? Object(arguments[i]) : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys.push.apply(ownKeys, Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import { createSelector } from 'reselect';
import { GiveawayGoodieSteps, GiveawayTypes } from 'swag-common/interfaces';
import { checkIsGiveawayWithGoodieType, checkIsGiveawayWithSwagType } from 'swag-common/utils/giveaway/giveaway-type.util';
import { shippingAddressValuesSelectorFactory } from 'swag-client-common/redux/partials/shipping-form/shipping-form.selectors';
import { getProductSizeSettingsOptions, hasMultipleGiveawayProductSizeVariants } from 'swag-common/business-logic/giveaway/giveaway-product-size-variants';
import { GiveawayLinkType, GiveawayProductChoice, GiveawayTypeAlternativeLabels } from 'swag-common/constants/giveaway.constants';
import { selectedGoodieProductsSelector, totalPriceOfSelectedGoodieProductsSelector, selectedGoodieProductsIdsSelector } from 'swag-client-common/redux/goodie-giveaway/selectors/goodie-giveaway-selection.selectors';
import { getAvailableQuantity } from 'swag-common/business-logic/giveaway/calculate-available-quantity';
import { Price } from 'swag-client-common/utils/price';
import { getGiveawayColorWithFallback } from 'swag-common/utils/giveaway/giveaway-colors.util';
import { showLoadingOverlaySelector } from '../../../custom-store-admin/redux/common/common.selectors';
import { pathnameSelector } from '../routing/routing.selectors';
import { getGiveawayProductColors, isOneSize } from './utils/get-giveaway-product-colors';
import { getSelectedAmount } from './utils/get-selected-amount';
import { validateColorVariant } from './utils/validate-color-variant';
import { isValidGiveawayShippingForm } from './utils/is-valid-giveaway-shipping-form';
export const giveawayLandingSelector = state => state.giveawayLanding;
export const giveawayLandingShippingDataSelector = createSelector(giveawayLandingSelector, state => state.shippingData);
export const selectedGiveawaySelector = createSelector(giveawayLandingSelector, giveaway => giveaway.selectedGiveaway);
export const isOneProductSelector = createSelector(selectedGiveawaySelector, giveaway => Boolean(giveaway === null || giveaway === void 0 ? void 0 : giveaway.isOneProduct));
export const selectedGiveawayBudgetSelector = createSelector(selectedGiveawaySelector, giveaway => (giveaway === null || giveaway === void 0 ? void 0 : giveaway.budget) || 0);
export const selectedGiveawayTypeSelector = createSelector(selectedGiveawaySelector, giveaway => (giveaway === null || giveaway === void 0 ? void 0 : giveaway.giveawayType) || GiveawayTypes.swag);
export const isCurrentGiveawayReserveSelector = createSelector(giveawayLandingSelector, giveaway => {
  var _giveaway$selectedGiv;
  return (_giveaway$selectedGiv = giveaway.selectedGiveaway) === null || _giveaway$selectedGiv === void 0 ? void 0 : _giveaway$selectedGiv.isReserve;
});
export const variantCapMapSelector = createSelector(giveawayLandingSelector, giveaway => {
  var _giveaway$selectedGiv2;
  return (_giveaway$selectedGiv2 = giveaway.selectedGiveaway) === null || _giveaway$selectedGiv2 === void 0 ? void 0 : _giveaway$selectedGiv2.variantCapMap;
});
export const selectedItemsSelector = createSelector(giveawayLandingSelector, giveaway => giveaway.selectedItems);
export const giveawayLandingActiveItemsSelector = createSelector(selectedItemsSelector, selectedItems => selectedItems);
export const currentGiveawayVariantsSelector = createSelector(giveawayLandingSelector, landing => landing.colorAndSizeVariants);
export const giveawayLinkRootSelector = createSelector(giveawayLandingSelector, landing => landing.giveawayLink);
export const giveawayLinkUpdateRequestedItemSelector = createSelector(giveawayLinkRootSelector, link => link.updateRequested);
export const giveawayLinkItemItemSelector = createSelector(giveawayLinkRootSelector, giveawayLink => giveawayLink.item);
export const giveawayLinkLoadedItemSelector = createSelector(giveawayLinkRootSelector, giveawayLink => giveawayLink.loaded);
export const selectedGiveawayProductsSelector = createSelector(selectedGiveawaySelector, giveaway => giveaway ? giveaway.products : []);
export const selectedGiveawayProductChoiceSelector = createSelector(selectedGiveawaySelector, giveaway => giveaway ? giveaway.productChoice : '');
export const selectedGiveawayPrimaryColorSelector = createSelector(selectedGiveawaySelector, giveaway => giveaway ? giveaway.primaryColor : '');
export const selectedGiveawayColorWithFallbackSelector = createSelector(selectedGiveawayPrimaryColorSelector, giveawayColor => getGiveawayColorWithFallback(giveawayColor));
export const multipleProductsQuantitiesSelector = createSelector(giveawayLandingSelector, giveaway => giveaway.multipleProductsQuantities);
export const multipleProductsQuantitiesStatusSelector = createSelector(giveawayLandingSelector, giveaway => giveaway.multipleProductsQuantitiesStatus);
export const giveawayLandingProductQuantitySelector = createSelector(selectedGiveawaySelector, giveaway => giveaway ? giveaway.productQuantity : 1);
export const giveawayLinkFormWithEmailSelector = createSelector(giveawayLinkItemItemSelector, link => Boolean(link && link.type === GiveawayLinkType.single));
export const giveawayLinkRouteSelector = createSelector(giveawayLinkItemItemSelector, item => (item === null || item === void 0 ? void 0 : item.link) || '');
export const shippingAddressValuesSelector = createSelector(giveawayLandingShippingDataSelector, giveawayLinkFormWithEmailSelector, shippingAddressValuesSelectorFactory);
const productParameterSelector = (_, {
  product
}) => product;
const productIdFromProductParameterSelector = (_, {
  product: {
    _id: productId
  }
}) => productId;
const productIdParameterSelector = (_, {
  productId
}) => productId;
export const selectedColorsSelector = createSelector(currentGiveawayVariantsSelector, productIdFromProductParameterSelector, (selections, productId) => {
  const variant = selections[productId];
  return (variant === null || variant === void 0 ? void 0 : variant.colors) || [];
});
export const selectedGiveawayProductsWithAvailableSelector = createSelector(selectedGiveawayProductsSelector, products => {
  const list = [];
  products.forEach(product => {
    if (product.variants.length) {
      list.push(_objectSpread({}, product, {
        available: getAvailableQuantity({
          quantity: product.inStock,
          inProductionQuantity: product.inProduction,
          inReserveQuantity: product.inReserveQuantity
        }) > 0
      }));
    }
  });
  return list;
});
export const isGiveawayLandingProductSelectedSizeSelector = createSelector(currentGiveawayVariantsSelector, productIdFromProductParameterSelector, (selections, productId) => {
  const variant = selections[productId];
  return variant ? variant.size : '';
});
export const hasGiveawayLandingProductSizesSelector = createSelector(productParameterSelector, hasMultipleGiveawayProductSizeVariants);
export const giveawayLandingProductSizesSettingsSelector = createSelector(productParameterSelector, getProductSizeSettingsOptions);
export const isGiveawayAndLinkLoadedSelector = createSelector(showLoadingOverlaySelector, giveawayLinkLoadedItemSelector, (isLoading, isGiveawayLinkLoaded) => !isLoading && isGiveawayLinkLoaded);
export const giveawayErrorSelector = createSelector(giveawayLandingSelector, landing => landing.error);
export const hasGiveawayErrorSelector = createSelector(giveawayErrorSelector, error => !!error);
export const giveawayLandingProductImageSelector = createSelector((state, props) => props.product, currentGiveawayVariantsSelector, productIdFromProductParameterSelector, (product, selectedVariants, productId) => {
  const {
    variants
  } = product;
  if (!variants.length) {
    return '';
  }
  const {
    defaultImage
  } = variants[0];
  const selectedVariant = selectedVariants[productId];
  const variant = variants.find(v => v.colorValue === selectedVariant.colors[0]);
  if (variant) {
    return variant.defaultImage || defaultImage;
  }
  return defaultImage || '';
});
export const currentGiveawaySelector = createSelector(giveawayLandingSelector, giveaway => giveaway.selectedGiveaway);
export const currentGiveawayChoiceLimit = createSelector(currentGiveawaySelector, giveaway => giveaway === null || giveaway === void 0 ? void 0 : giveaway.productQuantity);
export const isChoiceProductsGiveaway = createSelector(currentGiveawaySelector, selectedGiveaway => (selectedGiveaway === null || selectedGiveaway === void 0 ? void 0 : selectedGiveaway.productChoice) === GiveawayProductChoice.choice);
export const isOfferAllProductsGiveaway = createSelector(isChoiceProductsGiveaway, isChoiceProducts => !isChoiceProducts);
export const isValidGiveawayShippingFormSelector = createSelector(shippingAddressValuesSelector, giveawayLinkFormWithEmailSelector, isValidGiveawayShippingForm);
function isAvailable({
  isReserve,
  availableQuantity
}) {
  const num = isReserve ? availableQuantity : Infinity;
  return num > 0;
}
export const productsColorVariantsSelector = createSelector(selectedGiveawayProductsSelector, currentGiveawayVariantsSelector, multipleProductsQuantitiesSelector, isCurrentGiveawayReserveSelector, variantCapMapSelector, isOneProductSelector, isOfferAllProductsGiveaway, (products, selections, multipleProductsQuantities, isReserve, variantCapMapArray, isOneProduct, isOfferAllProducts) => {
  return products.reduce((result, product) => {
    const variant = selections[product._id];
    const selectedByUserColors = (variant === null || variant === void 0 ? void 0 : variant.colors) || [];
    const selectedSize = variant.size;
    const colorVariantsByColorValue = getGiveawayProductColors(product, true);
    const colorVariantsArray = Object.values(colorVariantsByColorValue);
    const isOnlyOneColor = colorVariantsArray.length === 1;
    const colorVariantWithQuantities = colorVariantsArray.reduce((result, colorVariant) => {
      let totalAmountForColorVariant = 0;
      let isSelectedColor = selectedByUserColors.includes(colorVariant.colorValue);
      const obj = colorVariantsByColorValue[colorVariant.colorValue];
      if (obj) {
        const selectedQuantities = obj.sizes.reduce((result, size) => {
          const sizeAndVariantId = obj.sizesAndVariantIds.find(item => item.sizeValue === size);
          if (!sizeAndVariantId) {
            return result;
          }
          const isVariantAvailable = isAvailable({
            isReserve,
            availableQuantity: obj.availableQuantity
          });

          // select first available color variant by default if this is the only one available option

          const isFirstColorPreselected = isOfferAllProducts && isOnlyOneColor && isVariantAvailable;
          const {
            variantId,
            sizeValue,
            availableQuantity
          } = sizeAndVariantId;
          const amount = getSelectedAmount({
            multipleProductsQuantities,
            variantId: sizeAndVariantId.variantId,
            isOneProduct,
            isSelectedColor: isSelectedColor || isFirstColorPreselected,
            isSelectedSize: selectedSize === sizeValue,
            isOneSizeProduct: isOneSize(sizeValue)
          });
          totalAmountForColorVariant += amount;
          result.push({
            variantId,
            amount,
            sizeValue,
            availableQuantity: isReserve ? availableQuantity : Infinity
          });
          return result;
        }, []);
        const variantCapMap = (variantCapMapArray || []).reduce((acc, variantCapMapObject) => {
          const key = variantCapMapObject.colorVariantId || variantCapMapObject.customProductParentId;
          acc[String(key)] = variantCapMapObject.capAmount;
          return acc;
        }, {});
        const isVariantAvailable = isAvailable({
          isReserve,
          availableQuantity: obj.availableQuantity
        });

        // select first available color variant by default if this is the only one available option
        if (isOfferAllProducts && isOnlyOneColor && isVariantAvailable && !isSelectedColor) {
          isSelectedColor = true;
          if (isOneProduct) {
            const singleSizeObj = selectedQuantities.find(item => isOneSize(item.sizeValue));
            if (singleSizeObj) {
              totalAmountForColorVariant = 1;
              singleSizeObj.amount = 1;
            }
          }
        }
        const errors = validateColorVariant({
          totalAmountForColorVariant,
          parentId: obj.parentId,
          colorVariantId: obj.colorVariantId,
          selectedQuantities,
          variantCapMap,
          isReserve,
          isOneProduct,
          isSelected: isSelectedColor
        });
        result.push(_objectSpread({}, obj, {
          isSelected: isSelectedColor,
          errors,
          selectedQuantities,
          isAvailable: isVariantAvailable
        }));
      } else {
        result.push(_objectSpread({}, colorVariant, {
          isSelected: false,
          errors: [],
          selectedQuantities: [],
          isAvailable: isAvailable({
            isReserve,
            availableQuantity: colorVariant.availableQuantity
          })
        }));
      }
      return result;
    }, []);
    result[product._id] = colorVariantWithQuantities;
    return result;
  }, {});
});
export const colorVariantsSelector = createSelector(productsColorVariantsSelector, productIdParameterSelector, (productsColorVariants, productId) => {
  return productsColorVariants[productId] || [];
});
export const selectedProductsSelector = createSelector(productsColorVariantsSelector, productColorVariants => {
  return Object.values(productColorVariants).reduce((result, colorVariants) => {
    Object.values(colorVariants).forEach(colorVariant => {
      if (!colorVariant.isSelected) {
        return;
      }
      const id = colorVariant.parentId;
      result.add(id);
    });
    return result;
  }, new Set());
});
export const selectedProductsAmountSelector = createSelector(selectedProductsSelector, selectedProducts => {
  return selectedProducts.size;
});
export const areSelectedProductsValidSelector = createSelector(isChoiceProductsGiveaway, productsColorVariantsSelector, currentGiveawayChoiceLimit, selectedProductsAmountSelector, giveawayLandingActiveItemsSelector, isOfferAllProductsGiveaway, (isChoice, productColorVariants, choiceLimit, selectedProductsAmount, giveawayLandingActiveItems, isOfferAllProducts) => {
  let isAnySelectedVariantInvalid = false;
  let isAnyVariantSelected = false;
  let isAnyProductSelectedButVariantNot = false;
  let isEveryAvailableProductSelected = true;
  Object.values(productColorVariants).forEach(colorVariants => {
    var _colorVariants$;
    let isEveryUnselected = true;
    let isSomeVariantOfProductSelected = false;
    let isAnyVariantAvailable = false;
    Object.values(colorVariants).forEach(colorVariant => {
      if (colorVariant.isSelected) {
        isAnyVariantSelected = true;
        isEveryUnselected = false;
        isSomeVariantOfProductSelected = true;
      }
      if (colorVariant.isAvailable) {
        isAnyVariantAvailable = true;
      }
      if (colorVariant.isSelected && colorVariant.errors) {
        isAnySelectedVariantInvalid = true;
      }
    });
    if (!isSomeVariantOfProductSelected && isAnyVariantAvailable) {
      isEveryAvailableProductSelected = false;
    }
    const firstVariantParentId = ((_colorVariants$ = colorVariants[0]) === null || _colorVariants$ === void 0 ? void 0 : _colorVariants$.parentId) && String(colorVariants[0].parentId);
    if (isEveryUnselected && firstVariantParentId && giveawayLandingActiveItems.includes(firstVariantParentId)) {
      isAnyProductSelectedButVariantNot = true;
    }
  }, {});
  if (!isAnyVariantSelected || isAnySelectedVariantInvalid || isAnyProductSelectedButVariantNot) {
    return false;
  }
  if (isOfferAllProducts && !isEveryAvailableProductSelected) {
    return false;
  }
  if (isChoice && Number.isFinite(choiceLimit) && selectedProductsAmount > choiceLimit) {
    return false;
  }
  return true;
});
export const giveawayVariantsToSendSelector = createSelector(productsColorVariantsSelector, productsColorVariants => {
  const userSelections = {};
  Object.values(productsColorVariants).forEach(colorVariantObjects => {
    colorVariantObjects.forEach(colorVariantObject => {
      if (!colorVariantObject.isSelected || colorVariantObject.errors) {
        return;
      }
      colorVariantObject.selectedQuantities.forEach(selectedQuantityObject => {
        if (selectedQuantityObject.amount <= 0) {
          return;
        }
        userSelections[selectedQuantityObject.variantId] = selectedQuantityObject.amount;
      });
    });
  });
  return userSelections;
});
export const isCurrentGiveawayLandingValidToSubmitSelector = createSelector(areSelectedProductsValidSelector, isValidGiveawayShippingFormSelector, selectedGiveawaySelector, selectedGoodieProductsIdsSelector, (areSelectedProductsValid, shipping, giveaway, goodieProducts) => {
  const areValidProducts = checkIsGiveawayWithSwagType(giveaway) ? areSelectedProductsValid : Object.keys(goodieProducts).length;
  return shipping && areValidProducts;
});
export const isTotalOfSelectedProductsBiggerThanBudgetSelector = createSelector(selectedGiveawayBudgetSelector, totalPriceOfSelectedGoodieProductsSelector, (budget, selectedTotal) => selectedTotal > budget);
export const isCurrentGiveawayLandingSubmitButtonDisabledSelector = createSelector(isCurrentGiveawayLandingValidToSubmitSelector, showLoadingOverlaySelector, selectedGiveawaySelector, pathnameSelector, selectedGoodieProductsSelector, isTotalOfSelectedProductsBiggerThanBudgetSelector, (isValid, isLoading, giveaway, pathname, selectedProducts, isTotalInvalid) => {
  if (checkIsGiveawayWithSwagType(giveaway)) {
    return !isValid || isLoading;
  }
  if (checkIsGiveawayWithGoodieType(giveaway)) {
    if (pathname.includes(GiveawayGoodieSteps.checkout)) {
      return !isValid || isLoading || isTotalInvalid;
    }
    return selectedProducts.length === 0 || isLoading || isTotalInvalid;
  }
  return false;
});
export const formattedSelectedGiveawayBudgetSelector = createSelector(selectedGiveawayBudgetSelector, budget => Price.formatPrice(budget, {
  onlyInteger: true
}));
export const shouldShowGoodieBudgetConfirmationPopup = createSelector(totalPriceOfSelectedGoodieProductsSelector, selectedGiveawayBudgetSelector, (totalSelectedProducts, budget) => {
  return budget - totalSelectedProducts >= Price.addDecimalToNumber(1);
});
export const giveawayTypeLandingSelector = createSelector(selectedGiveawaySelector, giveaway => (giveaway === null || giveaway === void 0 ? void 0 : giveaway.giveawayType) || GiveawayTypes.swag);
export const isGoodieGiveawayLanding = createSelector(giveawayTypeLandingSelector, giveawayType => {
  return checkIsGiveawayWithGoodieType({
    giveawayType
  });
});
export const giveawayTypeLabelLandingSelector = createSelector(giveawayTypeLandingSelector, type => {
  return GiveawayTypeAlternativeLabels[type];
});
export const giveawayTypeLabelLowercaseLandingSelector = createSelector(giveawayTypeLabelLandingSelector, label => label.toLowerCase());
export const giveawayLinkToGoSelector = link => createSelector(giveawayLinkLoadedItemSelector, giveawayLinkItemItemSelector, (linkLoaded, linkItem) => link || linkLoaded && (linkItem === null || linkItem === void 0 ? void 0 : linkItem.link) || '');